var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 11.4375C14.9375 11.2812 15.5625 12.3125 14.9688 13.0625C13.5 14.9062 11.2188 16 8.75 16C4.34375 16 0.75 12.4375 0.75 8C0.75 3.59375 4.34375 0 8.75 0C9.25 0.03125 9.75 0.0625 10.2188 0.15625C11.1562 0.3125 11.3438 1.53125 10.5312 2C8.9375 2.90625 7.96875 4.59375 7.96875 6.4375C7.96875 9.625 10.875 12.0312 14 11.4375ZM8.75 15C10.9688 15 12.9062 14 14.1875 12.4375C10.4375 13.125 6.96875 10.2812 6.96875 6.4375C6.96875 4.15625 8.1875 2.1875 10.0312 1.125C9.625 1.0625 9.1875 1 8.75 1C4.90625 1 1.75 4.15625 1.75 8C1.75 11.875 4.90625 15 8.75 15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.d74d0a336326110896f1599ac9b4ab03.svg";
export { ForwardRef as ReactComponent };